/* Titan League · tarjetas extra: frutas nuevas, paquetes y físicos (cada uno en su filtro) */
(function () {
  if (window.__titanExtraCards) return;
  window.__titanExtraCards = true;
  var CDN = 'https://cdn.shopify.com/s/files/1/0842/7782/1675/files/';
  var FRUITS = [
    ['Sand', 'sand arena', 'DF4ACC67-7123-46F0-A887-E052663522F0.webp?v=1789603560', 199, '11.06', 'Poco común', 'uncommon'],
    ['Eagle', 'eagle aguila águila', 'IMG-2934.webp?v=1789603546', 219, '12.17', 'Poco común', 'uncommon'],
    ['Dark', 'dark oscuridad', '8693C589-3040-43E0-844E-D0E590400F4B.webp?v=1789603530', 239, '13.28', 'Poco común', 'uncommon'],
    ['Light', 'light luz', 'IMG-2936.webp?v=1789603510', 269, '14.94', 'Rara', 'rare'],
    ['Rubber', 'rubber goma hule', 'IMG-2937.webp?v=1789603487', 289, '16.06', 'Rara', 'rare'],
    ['Love', 'love amor', '9AB0FDD5-D54E-49F3-B92C-48A119C0EC7D.webp?v=1789603469', 379, '21.06', 'Legendaria', 'legendary'],
    ['Lightning', 'lightning rumble rayo trueno', 'B2F4A08F-B476-493A-9619-0AC6A610AB02.webp?v=1789603449', 429, '23.83', 'Legendaria', 'legendary'],
    ['Blizzard', 'blizzard ventisca nieve', 'IMG-2940.webp?v=1789603424', 429, '23.83', 'Legendaria', 'legendary']
  ];

  function card(f) {
    var img = CDN + f[2];
    var handle = 'fruta-permanente-' + f[0].toLowerCase();
    var a = document.createElement('article');
    a.className = 'tlf2-card';
    a.tabIndex = 0;
    a.setAttribute('role', 'button');
    a.setAttribute('data-name', f[1]);
    a.setAttribute('data-fruit', f[0]);
    a.setAttribute('data-img', img);
    a.setAttribute('data-mxn', String(f[3]));
    a.setAttribute('data-usd', f[4]);
    a.setAttribute('data-rarity', f[5]);
    a.setAttribute('data-handle', handle);
    a.setAttribute('data-tags', 'new ' + f[6] + (f[3] <= 350 ? ' budget' : ''));
    a.setAttribute('aria-label', 'Ver ' + f[0] + ' permanente y comprar');
    a.innerHTML =
      '<div class="tlf2-card-light"></div>' +
      '<div class="tlf2-art"><img src="' + img + '" alt="' + f[0] + ' de Blox Fruits" loading="lazy"></div>' +
      '<div class="tlf2-meta"><span>' + f[5] + '</span><span>PERMANENTE ∞</span></div>' +
      '<h3>' + f[0] + '</h3>' +
      '<div class="tlf2-price"><strong>$' + f[3] + ' <small>MXN</small></strong><span>$' + f[4] + ' USD</span></div>' +
      '<button class="tlf2-open" type="button">Ver y comprar <b>→</b></button>';
    return a;
  }

  function fixScrolls(grid) {
    var a = grid.querySelector('[data-handle="pase-mythical-scrolls"]');
    var b = grid.querySelector('[data-handle="pase-legendary-scrolls"]');
    if (!a || !b || a.getAttribute('data-tl-fixed')) return;
    ['data-img'].forEach(function (k) {
      var va = a.getAttribute(k), vb = b.getAttribute(k);
      if (vb !== null) a.setAttribute(k, vb); else a.removeAttribute(k);
      if (va !== null) b.setAttribute(k, va); else b.removeAttribute(k);
    });
    var ia = a.querySelector('.tlf2-art img'), ib = b.querySelector('.tlf2-art img');
    if (ia && ib) { var t = ia.src; ia.src = ib.src; ib.src = t; }
    a.setAttribute('data-tl-fixed', '1');
    b.setAttribute('data-tl-fixed', '1');
  }

  var P = {
    dragon: CDN + 'dragon_7eeaa49b-929e-4447-bfec-7c5a6db7fd01.webp?v=1787540896',
    dough: CDN + 'dough.webp?v=1787540896',
    portal: CDN + 'portal.webp?v=1787540896',
    magma: CDN + 'magma.webp?v=1787540896',
    blade: CDN + 'tl-badge-dark-blade.webp?v=1789353882',
    notifier: CDN + 'tl-pass-fruit-notifier_ab874888-e0dd-4890-b4df-fa948da765dc.png?v=1789350166',
    money: CDN + 'tl-pass-2x-money_85d541a1-b0ef-4866-9807-4e72bae00f0f.png?v=1789350168',
    mastery: CDN + 'tl-pass-2x-mastery_1d3c0cba-ead5-45dd-bd0b-2680322ba708.png?v=1789350172',
    boats: CDN + 'tl-pass-fast-boats_c9a0c12a-f438-47eb-ada6-4b392e0242c2.png?v=1789350170'
  };
  var PACKS = [
    { h: 'paquete-mini-titan', name: 'Paquete Mini Titán', mxn: 399, was: 492,
      items: [P.magma, P.mastery, P.boats], list: 'Magma + 2x Mastery + Fast Boats' },
    { h: 'paquete-pvp-titan', name: 'Paquete PvP Titán', mxn: 699, was: 887,
      items: [P.portal, P.blade, P.mastery], list: 'Portal + Dark Blade + 2x Mastery' },
    { h: 'paquete-farmeo-titan', name: 'Paquete Farmeo Titán', mxn: 899, was: 1217,
      items: [P.dough, P.money, P.notifier], list: 'Dough + 2x Money + Fruit Notifier' },
    { h: 'paquete-titan-super', name: 'Paquete Titán Súper', mxn: 1099, was: 1286,
      items: [P.dragon, P.blade, P.mastery], list: 'Dragón + Dark Blade + 2x Mastery + Fruit Storage' }
  ];

  // Productos físicos (llegan por paquetería)
  var FISICOS = [
    { h: 'paquete-kitsune-dlc-premium', name: 'Paquete Kitsune + DLC Premium', mxn: 2199,
      img: CDN + '8D310521-3FFA-42A3-A65F-1F8C3D842B5D.png?v=1789867802',
      list: '2 peluches + 2 minifiguras + póster + código DLC Premium + caja Kitsune',
      tagline: '7 ARTÍCULOS' }
  ];

  function packCard(p) {
    var a = document.createElement('article');
    a.className = 'tlf2-card tlf2-card--pack';
    a.tabIndex = 0;
    a.setAttribute('role', 'button');
    a.setAttribute('data-name', p.name.toLowerCase() + ' paquete combo pack');
    a.setAttribute('data-fruit', p.name);
    a.setAttribute('data-img', p.items[0]);
    a.setAttribute('data-mxn', String(p.mxn));
    a.setAttribute('data-rarity', 'Paquete');
    a.setAttribute('data-handle', p.h);
    a.setAttribute('data-tags', 'pack');
    a.setAttribute('aria-label', 'Ver ' + p.name);
    var arts = p.items.map(function (src, i) {
      var cls = ['pk-a', 'pk-b', 'pk-c'][i] || 'pk-c';
      return '<img class="pk ' + cls + '" src="' + src + '" alt="" loading="lazy">';
    }).join('');
    a.innerHTML =
      '<div class="tlf2-card-light"></div>' +
      '<div class="tlf2-art tlf2-art--pack">' + arts + '</div>' +
      '<div class="tlf2-meta"><span>PAQUETE</span><span>AHORRAS $' + (p.was - p.mxn) + '</span></div>' +
      '<h3>' + p.name + '</h3>' +
      '<p class="pk-list">' + p.list + '</p>' +
      '<div class="tlf2-price"><strong>$' + p.mxn + ' <small>MXN</small></strong>' +
        '<span class="tlf2-was">$' + p.was + '</span></div>' +
      '<button class="tlf2-open" type="button">Ver y comprar <b>→</b></button>';
    return a;
  }

  function fisicoCard(p) {
    var a = document.createElement('article');
    a.className = 'tlf2-card tlf2-card--fisico';
    a.tabIndex = 0;
    a.setAttribute('role', 'button');
    a.setAttribute('data-name', p.name.toLowerCase() + ' fisico físico juguete peluche coleccionable');
    a.setAttribute('data-fruit', p.name);
    a.setAttribute('data-img', p.img);
    a.setAttribute('data-mxn', String(p.mxn));
    a.setAttribute('data-rarity', 'Producto físico');
    a.setAttribute('data-handle', p.h);
    a.setAttribute('data-tags', 'fisico');
    a.setAttribute('aria-label', 'Ver ' + p.name);
    a.innerHTML =
      '<div class="tlf2-card-light"></div>' +
      '<div class="tlf2-art"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy"></div>' +
      '<div class="tlf2-meta"><span>FÍSICO · ENVÍO</span><span>' + p.tagline + '</span></div>' +
      '<h3>' + p.name + '</h3>' +
      '<p class="pk-list">' + p.list + '</p>' +
      '<div class="tlf2-price"><strong>$' + p.mxn.toLocaleString('es-MX') + ' <small>MXN</small></strong></div>' +
      '<button class="tlf2-open" type="button">Ver y comprar <b>→</b></button>';
    return a;
  }

  function extraStyles() {
    if (document.getElementById('tl-pack-css')) return;
    var st = document.createElement('style');
    st.id = 'tl-pack-css';
    st.textContent =
      '.tlf2-card--pack,.tlf2-card--fisico{display:none!important}' +
      'body.tl-packs .tlf2-card--pack:not(.hidden){display:flex!important}' +
      'body.tl-fisicos .tlf2-card--fisico:not(.hidden){display:flex!important}' +
      '.tlf2-card--pack{border-color:#ffd22866!important;box-shadow:0 14px 34px #0009,0 0 0 1px #ffd22833!important}' +
      '.tlf2-card--fisico{border-color:#46c08a88!important;box-shadow:0 14px 34px #0009,0 0 0 1px #46c08a33!important}' +
      '.tlf2-card--fisico .tlf2-meta span:first-child{color:#6ee7b7}' +
      '.tlf2-art--pack{position:relative;display:block}' +
      '.tlf2-art--pack .pk{position:absolute;object-fit:contain;filter:drop-shadow(0 6px 10px #000a)}' +
      '.tlf2-art--pack .pk-a{width:62%;height:62%;left:4%;top:16%;z-index:3}' +
      '.tlf2-art--pack .pk-b{width:44%;height:44%;right:4%;top:6%;z-index:2}' +
      '.tlf2-art--pack .pk-c{width:44%;height:44%;right:8%;bottom:2%;z-index:1}' +
      '.pk-list{margin:2px 0 8px;color:#b9a9d6;font-size:12px;line-height:1.35;font-weight:700}' +
      '.tlf2-card--pack .tlf2-meta span:last-child{color:#ffd228}' +
      '.tlf2-filter--pack{border-color:#ffd228!important;color:#ffd228!important;background:linear-gradient(135deg,rgba(255,210,40,.18),rgba(156,53,255,.14))!important}' +
      '.tlf2-filter--pack.active{background:linear-gradient(135deg,#ffd228,#a855ff)!important;color:#241a00!important;border-color:#ffd228!important}' +
      '.tlf2-filter--fisico{border-color:#46c08a!important;color:#6ee7b7!important;background:linear-gradient(135deg,rgba(70,192,138,.18),rgba(56,189,248,.10))!important}' +
      '.tlf2-filter--fisico.active{background:linear-gradient(135deg,#46c08a,#38bdf8)!important;color:#04150f!important;border-color:#6ee7b7!important}';
    document.head.appendChild(st);
  }

  function addFilter(cls, value, label) {
    var bar = document.querySelector('#tlf-shop .tlf2-filters');
    if (!bar || bar.querySelector('[data-filter="' + value + '"]')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tlf2-filter ' + cls;
    b.setAttribute('data-filter', value);
    b.textContent = label;
    var skin = bar.querySelector('.tlf2-filter--skin');
    if (skin) bar.insertBefore(b, skin); else bar.appendChild(b);
  }

  function watchFilters() {
    function sync() {
      var act = document.querySelector('#tlf-shop .tlf2-filter.active');
      var f = act ? act.getAttribute('data-filter') : 'all';
      var q = (document.querySelector('#tlf-shop .tlf2-search') || {}).value || '';
      document.body.classList.toggle('tl-packs', f === 'pack' || /paq|pack|combo/i.test(q));
      document.body.classList.toggle('tl-fisicos', f === 'fisico' || /físic|fisic|peluche|juguete|kitsune bundle/i.test(q));
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.tlf2-filter')) setTimeout(sync, 20);
    });
    var s = document.querySelector('#tlf-shop .tlf2-search');
    if (s) s.addEventListener('input', function () { setTimeout(sync, 20); });
    sync();
  }

  var done = false;
  function insert() {
    if (done) return true;
    var empty = document.getElementById('tlf2-empty');
    if (!empty || !document.getElementById('tlf-shop')) return false;
    var grid = empty.parentNode;
    var before = grid.querySelector('.tlf2-card--caja') || empty;
    FRUITS.forEach(function (f) {
      if (!grid.querySelector('[data-handle="fruta-permanente-' + f[0].toLowerCase() + '"]')) {
        grid.insertBefore(card(f), before);
      }
    });
    extraStyles();
    addFilter('tlf2-filter--pack', 'pack', 'Paquetes');
    addFilter('tlf2-filter--fisico', 'fisico', 'Físicos');
    var firstCard = grid.querySelector('.tlf2-card');
    PACKS.forEach(function (p) {
      if (grid.querySelector('[data-handle="' + p.h + '"]')) return;
      var node = packCard(p);
      if (firstCard) grid.insertBefore(node, firstCard); else grid.insertBefore(node, before);
    });
    FISICOS.forEach(function (p) {
      if (grid.querySelector('[data-handle="' + p.h + '"]')) return;
      var node = fisicoCard(p);
      if (firstCard) grid.insertBefore(node, firstCard); else grid.insertBefore(node, before);
    });
    fixScrolls(grid);
    done = true;
    return true;
  }

  if (!insert() && window.MutationObserver) {
    var obs = new MutationObserver(function () {
      if (insert()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () { obs.disconnect(); insert(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchFilters();
    var eb = document.querySelector('#catalogo-frutas .tlf2-section-head .tlf2-eyebrow');
    if (eb) eb.textContent = '31 permanentes · 4 paquetes · 9 passes · 3 skins · 1 físico';
  });
})();
